/**
 * @generated SignedSource<<dc9546c926572acd72c208d11dcb042a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AppConnectHttpsSceneQuery$variables = {
  appId: string;
};
export type AppConnectHttpsSceneQuery$data = {
  readonly viewer: {
    readonly appById: {
      readonly cloudUrls: ReadonlyArray<{
        readonly httpEnabled: boolean;
        readonly url: string;
        readonly wsEnabled: boolean;
      }>;
    } | null | undefined;
  };
};
export type AppConnectHttpsSceneQuery = {
  response: AppConnectHttpsSceneQuery$data;
  variables: AppConnectHttpsSceneQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "appId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "appId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "wsEnabled",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "httpEnabled",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AppConnectHttpsSceneQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*:: as any*/),
            "concreteType": "App",
            "kind": "LinkedField",
            "name": "appById",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AppDomainStatus",
                "kind": "LinkedField",
                "name": "cloudUrls",
                "plural": true,
                "selections": [
                  (v2/*:: as any*/),
                  (v3/*:: as any*/),
                  (v4/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "QueryRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "AppConnectHttpsSceneQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*:: as any*/),
            "concreteType": "App",
            "kind": "LinkedField",
            "name": "appById",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AppDomainStatus",
                "kind": "LinkedField",
                "name": "cloudUrls",
                "plural": true,
                "selections": [
                  (v2/*:: as any*/),
                  (v3/*:: as any*/),
                  (v4/*:: as any*/),
                  (v5/*:: as any*/)
                ],
                "storageKey": null
              },
              (v5/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "67b8d24fa58bf6720697119157bd8716",
    "id": null,
    "metadata": {},
    "name": "AppConnectHttpsSceneQuery",
    "operationKind": "query",
    "text": "query AppConnectHttpsSceneQuery(\n  $appId: ID!\n) {\n  viewer {\n    appById(id: $appId) {\n      cloudUrls {\n        url\n        wsEnabled\n        httpEnabled\n        id\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4ab7df3d8aedd96cd532ff7d33fa0049";

export default node;
